import {
    SUCCESS_GET_ALLCLIENTEVENTS,
    FAILED_GET_ALLCLIENTEVENTS,
    SUCCESS_CREATE_CLIENTEVENT,
    FAILED_CREATE_CLIENTEVENT,
    SUCCESS_UPDATE_CLIENTEVENT,
    FAILED_UPDATE_CLIENTEVENT,
    SUCCESS_DELETE_CLIENTEVENT,
    FAILED_DELETE_CLIENTEVENT,
} from '../constants/clientEventConstants';

const defaultState = {
    clientEvents: [],
    needUpdateClientEvents: false,
    errorMessage: '',
};

export const ClientEventReducer = (state = defaultState, { type, payload, errorMessage }) => {
    switch (type) {

        case SUCCESS_GET_ALLCLIENTEVENTS:
            return {
                ...state,
                clientEvents: payload,
                needUpdateClientEvents: false,
                errorMessage: null,
            };

        case SUCCESS_CREATE_CLIENTEVENT:
            return {
                ...state,
                clientEvents: [...state.clientEvents, payload],
                errorMessage: null,
            };

        case SUCCESS_UPDATE_CLIENTEVENT: {
            const index = state.clientEvents.findIndex(ce => ce.id === payload.id);
            const _clientEvents = [...state.clientEvents];
            _clientEvents[index] = payload;

            return {
                ...state,
                needUpdateBookingLineDetails: true,
                clientEvents: _clientEvents,
            };
        }

        case SUCCESS_DELETE_CLIENTEVENT: {
            const index = state.clientEvents.findIndex(ce => ce.id === payload.id);
            const _clientEvents = [...state.clientEvents];
            _clientEvents.splice(index, 1);

            return {
                ...state,
                clientEvents: _clientEvents,
            };
        }

        case FAILED_GET_ALLCLIENTEVENTS:
        case FAILED_CREATE_CLIENTEVENT:
        case FAILED_UPDATE_CLIENTEVENT:
        case FAILED_DELETE_CLIENTEVENT:
            return {
                ...state,
                errorMessage: errorMessage
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/reducers/clientEventReducer.js